//@ts-nocheck
import React, { useMemo } from "react";
import {
  Delete,
  Edit,
  Save,
  Cancel,
  ArrowDownward,
  ArrowUpward,
  ExpandMore,
} from "@mui/icons-material";
import { Checkbox, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Table, TableBody, TableContainer, TableRow, TableHead, TableCell } from "@mui/material";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";
import { useState } from "react";
import MDTypography from "components/MDTypography";
import { NumericFormat } from "react-number-format";
import DataTableHeadCell from "lib/Tables/EditableTable/DataTableHeadCell";
import { formatCurrencyUSD } from "utils/CommonUtils";
import MDSelect from "components/MDSelect";

interface SyndicationFormProps {
  columns: any[];
  data: any[];
  onDelete: (id: number) => void;
  onEdit: (row: any | null) => void;
  onSave: (row: any) => void;
  onCancel: () => void;
  editingRow: any | null;
  isEditing: boolean;
  onInputChange: (value: string, field: string) => void;
  selectedRows: any[];
  onSelectRow: (rowKey: any) => void;
  onSelectAll: () => void;
  onSort: (columnKey: any) => void;
  getRowStyle: (row: any | null) => any;
  isActionsDisabled: (row: any | null) => any;
  renderTotal: (rows: any) => any | null;
  rowKey: any;
  totalColumn: any | null;
  handleAddNew: (value: string) => boolean;
}

const SyndicationForm: React.FC<SyndicationFormProps> = ({
  columns,
  data,
  onDelete,
  onEdit,
  onSave,
  onCancel,
  editingRow,
  isEditing,
  onInputChange,
  selectedRows,
  onSelectRow,
  onSelectAll,
  onSort,
  getRowStyle,
  isActionsDisabled,
  rowKey,
  renderTotal,
  totalColumn,
  handleAddNew,
}) => {
  const handleCheckboxChange = (rowKey: any) => {
    onSelectRow(rowKey);
  };

  const handleSelectAllChange = () => {
    onSelectAll();
  };

  const [search, setSearch] = useState("");

  const filteredData = data.filter((row) => {
    return columns.some((column) =>
      row[column.accessor]?.toString().toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <>
      <TableContainer sx={{ boxShadow: "none" }}>
        <Table style={{ width: "100%", borderCollapse: "collapse" }}>
          <MDBox component="thead">
            <TableRow>
              <TableCell
                align="center"
                padding="checkbox"
                sx={{ padding: "3px", width: "30px", maxWidth: "30px" }}
              >
                <Checkbox
                  checked={selectedRows.length === filteredData.length}
                  onChange={handleSelectAllChange}
                  color="primary"
                />
              </TableCell>
              {columns.map((column: any) => (
                <DataTableHeadCell
                  key={column.accessor}
                  align={column.align ? column.align : "left"}
                  sx={{ padding: "8px" }}
                >
                  <MDBox
                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                    onClick={() => onSort(column.accessor)}
                  >
                    {column.Header}
                  </MDBox>
                </DataTableHeadCell>
              ))}

              <DataTableHeadCell
                key={"actions"}
                align={"left"}
                style={{ width: "120px", padding: "8px" }}
              >
                Actions
              </DataTableHeadCell>
            </TableRow>
          </MDBox>

          <TableBody>
            {filteredData
              .filter((row: any) => {
                return !editingRow || editingRow[rowKey] !== row[rowKey];
              })
              .map((row: any) => (
                <TableRow key={row[rowKey]}>
                  <TableCell
                    align="center"
                    padding="checkbox"
                    sx={{ padding: "3px", width: "30px", maxWidth: "30px" }}
                  >
                    <Checkbox
                      checked={selectedRows.includes(row[rowKey])}
                      onChange={() => handleCheckboxChange(row[rowKey])}
                      color="primary"
                    />
                  </TableCell>

                  {columns.map((column: any) => {
                    const cellValue =
                      editingRow && editingRow[column.accessor] ? editingRow[column.accessor] : "";
                    return (
                      <TableCell
                        key={column.accessor}
                        style={{
                          padding: "8px",
                          textAlign: column.align || "center",
                          width: column.width || "auto",
                        }}
                      >
                        <MDBox>
                          {column.Cell ? (
                            <MDTypography fontSize={"0.75rem"} fontWeight={getRowStyle(row)}>
                              {" "}
                              {column.Cell({ row })}
                            </MDTypography>
                          ) : (
                            <MDTypography fontSize={"0.75rem"} fontWeight={getRowStyle(row)}>
                              {" "}
                              {row[column.accessor]}{" "}
                            </MDTypography>
                          )}
                        </MDBox>
                      </TableCell>
                    );
                  })}

                  <TableCell align="center" sx={{ padding: "8px" }}>
                    <MDBox display="flex" justifyContent="left" gap={0.5}>
                      {!row.defaultSyndicator && row["investmentPercentage"] && row["partyId"] && (
                        <MDButton
                          variant="text"
                          color="error"
                          onClick={() => onDelete(row)}
                          startIcon={<Delete />}
                          sx={{ minWidth: "auto", padding: "4px 8px" }}
                        >
                          Delete
                        </MDButton>
                      )}

                      {(row.applicationCommissionId
                        ? false
                        : true && !row.isFromCommission && !row.defaultSyndicator) && (
                        <MDButton
                          variant="text"
                          color="secondary"
                          onClick={() => onEdit(row)}
                          disabled={isActionsDisabled ? isActionsDisabled(row) : false}
                          startIcon={<Edit />}
                          sx={{ minWidth: "auto", padding: "4px 8px" }}
                        >
                          Edit
                        </MDButton>
                      )}
                    </MDBox>
                  </TableCell>
                </TableRow>
              ))}

            {isEditing && editingRow && (
              <TableRow
                sx={{ height: 100, verticalAlign: "bottom" }}
                key={editingRow[rowKey] || "new"}
              >
                <TableCell align="center" padding="checkbox" sx={{ padding: "8px" }}></TableCell>

                {columns.map((column: any) => {
                  const cellValue = editingRow[column.accessor] || "";

                  return (
                    <TableCell
                      key={column.accessor}
                      style={{
                        padding: "8px",
                        textAlign: column.align || "center",
                        width: column.width || "auto",
                      }}
                    >
                      <MDBox>
                        {column.accessor === "paybackAmount" ? (
                          <NumericFormat
                            variant="standard"
                            label={column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}
                            value={
                              (isNaN(editingRow?.fundedAmount)
                                ? 0
                                : parseFloat(editingRow?.fundedAmount)) +
                              (isNaN(editingRow?.expectedProfit)
                                ? 0
                                : parseFloat(editingRow?.expectedProfit))
                            }
                            thousandSeparator
                            prefix="$"
                            decimalScale={2}
                            fixedDecimalScale
                            allowNegative={false}
                            customInput={MDInput}
                            error={
                              column.required !== false ? isNaN(cellValue) || cellValue <= 0 : false
                            }
                            onValueChange={({ value }) => {
                              const formattedValue = parseFloat(value.replace(/[^0-9.-]+/g, ""));
                              onInputChange(formattedValue, column.accessor);
                            }}
                            inputProps={{
                              style: { fontSize: "0.75rem", fontWeight: 700 },
                            }}
                            sx={{ flexBasis: "40%" }}
                            disabled={column.disabled && column.disabled()}
                          />
                        ) : column.input === "select" ? (
                          <MDSelect
                            label={column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}
                            disableClearable={true}
                            isAddingNew={editingRow.showAddingNew}
                            newInputValue={editingRow?.newSyndicatorParty}
                            sx={{ minWidth: 120, maxWidth: column?.width || 500 }}
                            value={
                              column.selector
                                ? column.options?.find(
                                    (opt) => opt.value === editingRow[column.selector]
                                  )
                                : column.accessor
                                ? column.options?.find(
                                    (opt) => opt.value === editingRow[column.accessor]
                                  )
                                : null
                            }
                            options={[...(column.options || [])]}
                            onChange={(selectedOption) => {
                              if (!selectedOption) return;

                              if ((selectedOption as any).isAddNew) {
                                onInputChange(null, "addNew");
                                return;
                              }
                              const key = column.selector || column.accessor;
                              onInputChange(selectedOption.value, key);
                            }}
                            placeholder={column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}
                            disabled={column.disabled && column?.disabled()}
                            renderOption={(props, option) => {
                              const selectedValue =
                                editingRow[column.selector || column.accessor] || "";
                              const fundColor = option.fund > 0 ? "green" : "red";

                              return (
                                <li {...props}>
                                  {option.label}
                                  {option.fund !== undefined && option.value !== selectedValue && (
                                    <span
                                      style={{
                                        color: fundColor,
                                        marginLeft: 10,
                                        fontSize: "0.75rem",
                                      }}
                                    >
                                      {formatCurrencyUSD(option.fund)}
                                    </span>
                                  )}
                                </li>
                              );
                            }}
                            getOptionLabel={(option) => option.label}
                            addNewOption
                            onAddNewSubmit={(value: any) => {
                              return handleAddNew(value);
                            }}
                          />
                        ) : column.input === "checkbox" ? (
                          <Checkbox
                            checked={!!cellValue}
                            disabled={column.disabled && column.disabled()}
                            onChange={(e) => onInputChange(e.target.checked, column.accessor)}
                            sx={{ fontSize: 24 }}
                          />
                        ) : (
                          <MDInput
                            label={column?.Header?.toLowerCase()?.replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}
                            value={cellValue || ""}
                            onChange={(e) => onInputChange(e.target.value, column.accessor)}
                            error={column.required !== false ? !cellValue : false}
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 700,
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: "0.7rem",
                              },
                            }}
                            disabled={column.disabled && column.disabled()}
                          />
                        )}
                      </MDBox>
                    </TableCell>
                  );
                })}

                <TableCell align="center" sx={{ padding: "8px" }}>
                  <MDBox display="flex" justifyContent="center" gap={0.5}>
                    <MDButton
                      variant="text"
                      color="primary"
                      onClick={() => onSave(editingRow)}
                      startIcon={<Save />}
                      sx={{ minWidth: "auto", padding: "4px 8px" }}
                    >
                      Save
                    </MDButton>
                    <MDButton
                      variant="text"
                      color="secondary"
                      onClick={onCancel}
                      startIcon={<Cancel />}
                      sx={{ minWidth: "auto", padding: "4px 8px" }}
                    >
                      Cancel
                    </MDButton>
                  </MDBox>
                </TableCell>
              </TableRow>
            )}

            {renderTotal && (
              <TableRow key="totals">
                <TableCell></TableCell>
                <TableCell align="left" fontSize={"0.75rem"} fontWeight={"bold"}>
                  <MDTypography fontSize={"0.75rem"} fontWeight={"bold"}>
                    TOTAL:
                  </MDTypography>
                </TableCell>

                {columns.map((column, index) => {
                  if (index < 1) return;
                  if (totalColumn.includes(column.accessor)) {
                    return (
                      <TableCell key={column.accessor} sx={{ padding: "8px" }} align="left">
                        <MDTypography fontSize={"0.75rem"} fontWeight={"bold"}>
                          {renderTotal(column.accessor)}
                        </MDTypography>
                      </TableCell>
                    );
                  } else {
                    return (
                      <TableCell key={column.accessor} sx={{ padding: "8px" }}>
                        <MDTypography fontSize={"0.75rem"} fontWeight={700}></MDTypography>
                      </TableCell>
                    );
                  }
                })}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SyndicationForm;
